<script setup>
const currentYear = new Date().getFullYear()
</script>

<template>
  <footer>
    <div class="content">
      <div class="inner">
        <div
          class="w-full text-center lg:text-left lg:w-auto flex-initial flex items-center flex-wrap lg:flex-nowrap justify-center lg:justify-start"
        >
          <p>
            <img
              src="/logos/logo-small.png"
              width="27"
              alt="Logo"
              class="hidden xs:inline-block mr-[11px]"
            />
            Copyright &copy; 2001-{{ currentYear }} PSN s.r.o. All rights
            reserved
          </p>
          <span class="divider">|</span>
          <!--          <nuxt-link to="/" class="!underline hover:!no-underline"-->
          <!--          >GDPR-->
          <!--          </nuxt-link-->
          <!--          >-->
          <span class="divider">|</span>
          <a href="tel:+420773782589">
            <img
              src="/icons/phone-black.svg"
              width="27"
              alt="Ikona"
              class="inline-block mr-[8px] relative top-[-4px]"
            />
            <span class="!font-bold !mx-0">+420 773 782 589</span>
          </a>
          <span class="divider">|</span>
          <a href="mailto:concierge.vanguard@psn.cz">
            <img
              src="/icons/message.png"
              width="32"
              alt="Ikona"
              class="inline-block mr-[11px]"
            />
            <span class="!font-bold !mx-0">concierge.vanguard@psn.cz</span>
          </a>
        </div>

        <div class="w-full lg:w-auto flex-initial">
          <img src="/logos/logo-psn.png" class="logo-footer" alt="by PSN" />
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="postcss">
.inner {
  @apply border-t border-grey py-30 flex justify-center lg:justify-between items-center flex-wrap lg:flex-nowrap;
}

p,
a,
span {
  @apply text-black no-underline font-300 text-base flex items-center my-5 mx-15 lg:mx-0;
}

.divider {
  @apply mx-15 hidden lg:inline-block;
}

.logo-footer {
  @apply w-auto h-[35px] mx-auto mt-10 lg:mt-0 lg:mx-0;
}
</style>
